var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confirmation-email.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.21875 32.063V73.1593C2.21875 78.0438 6.17499 82.0001 11.0595 82.0001H72.9405C77.825 82.0001 81.7812 78.0438 81.7812 73.1593V32.063",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M29.2714 54.9473L4.82666 79.392",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M79.1776 79.392L54.7329 54.9473",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M15.4798 18.4437L6.13514 24.7295C0.927934 28.2305 0.927934 35.8954 6.13514 39.4008L32.1005 56.8701C38.0857 60.8971 45.9097 60.8971 51.8949 56.8701L77.8603 39.4008C83.0675 35.8954 83.0675 28.2349 77.8603 24.7295L68.5244 18.4437",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M68.5246 45.6866V6.42038C68.5246 3.98033 66.5442 2 64.1042 2H19.9004C17.4603 2 15.48 3.98033 15.48 6.42038V45.6866",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M28.7412 17.9046H55.2635",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M28.7412 33.376H55.2635",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmEmail);
export default __webpack_public_path__ + "static/media/confirmEmail.31ee061e4be8ce2d83a03a61d1da3f34.svg";
export { ForwardRef as ReactComponent };